var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55425",
    "data-name": "Group 55425",
    transform: "translate(-17.277 -55.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 52,
    height: 52,
    transform: "translate(17.277 55.277)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(23.22 67.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M374.6,344.38a1.706,1.706,0,0,1-1.841,1.117q-16.41-.025-32.819-.011h-.562c.165.177.262.288.366.392q4.837,4.828,9.677,9.652a1.529,1.529,0,0,1,.507,1.653,1.4,1.4,0,0,1-2.164.705,3.468,3.468,0,0,1-.4-.368q-6.121-6.119-12.24-12.241a1.479,1.479,0,0,1,0-2.427q6.147-6.148,12.293-12.3a1.492,1.492,0,0,1,1.65-.5,1.411,1.411,0,0,1,.636,2.215,4.41,4.41,0,0,1-.346.372q-4.79,4.792-9.584,9.58a2.413,2.413,0,0,1-.391.263l.089.158h.482q16.429,0,32.858.009a2.239,2.239,0,0,1,1.117.236c.293.178.458.567.679.864Z",
    transform: "translate(-334.481 -329.969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.505f156af6fadc4935c4e2868911fd84.svg";
export { ForwardRef as ReactComponent };